import client from "./client";

export default {

    async getTenancies(filters) {
        return client.parseResponse(await client.get('/tenancies', filters));
    },
    async getPendingTenancies(filters) {
        return client.parseResponse(await client.get('/pending-tenancies', filters));
    },
    async getTenancy(id) {
        return client.parseResponse(await client.get('/tenancies/' + id));
    },
    async getTenancyMetredReadings(id) {
        return client.parseResponse(await client.get('/tenancy-metred-readings/' + id));
    },
    async getPreviousReading(data) {
        return client.parseResponse(await client.get('/get-previous-reading', data));
    },
    async createTenancy(data) {
        return client.parseResponse(await client.post('/tenancies', data))
    },
    async endTenancy(data) {
        return client.parseResponse(await client.post('/end-tenancy', data))
    },
    async verifyTenancyInvite(data) {
        return client.parseResponse(await client.post('/tenancies/invite/verify', data))
    },
    async completeTenancyInvite(data) {
        return client.parseResponse(await client.post('/tenancies/invite/complete', data))
    },
    async revokePendingTenancy(id) {
        return client.parseResponse(await client.post('/pending-tenancies/' + id + '/revoke'))
    },
    async resendPendingTenancyInvite(id) {
        return client.parseResponse(await client.post('/pending-tenancies/' + id + '/resend'))
    },
    async previewPendingTenancyLease(id) {
        return client.parseResponse(await client.get('/pending-tenancies/' + id + '/lease-preview'))
    },
    async requestPayment(data) {
        return client.parseResponse(await client.post('/request-tenancy-payment', data))
    },
    async createMetredCharge(data) {
        return client.parseResponse(await client.post('/tenancy-metred-readings', data))
    },
    async editTenancy(data) {
        return client.parseResponse(await client.put('/tenancies/' + data.id, data))
    },
    async deleteTenancy(data) {
        return client.parseResponse(await client.delete('/tenancies/' + data.id, data))
    },
    async removeTenancy(data) {
        return client.parseResponse(await client.post('/remove-tenancy/' + data.id, data))
    },
    async transferTenancy(data) {
        return client.parseResponse(await client.post('/tenancies/' + data.tenancy_id + '/transfer', data))
    },

    async exportTenanciesReport(filters) {
        return client.parseResponse(await client.get('/export-tenancies', filters, {responseType: 'blob'}));
    }
}
